/**
 * Translations API client
 * Fetches Umbraco Dictionary items for the current language
 */

import { getEnv } from "@/config/env";
import { getJson } from "@/api/http";
import type { LocalizedTexts, Result } from "@/types/layout";

const TRANSLATIONS_ENDPOINT = "/translations";

/**
 * Fetches translations for the current store language (set via X-Store-Language header)
 */
export async function fetchTranslations(
  signal?: AbortSignal
): Promise<Result<LocalizedTexts>> {
  const url = `${getEnv().apiBaseUrl}${TRANSLATIONS_ENDPOINT}`;
  return getJson<LocalizedTexts>(url, signal ? { signal } : undefined);
}
